import { IServiceResponse } from '@sravni/types/lib/sitesettings';

import { IGlobalState } from '../index';

export const getSiteSettings = (state: IGlobalState): IServiceResponse => state.sitesettings;
